import { api, ApiRequestConfig } from './api';
import { ICreateLoyaltyResponse } from '../types/create-loyalty-request';
import { EKeycardType } from '../reducers';

interface ICreateLoyaltyRequestParams {
  keycardType: EKeycardType;
  marketingConsent: boolean;
  regionId: string;
}

export const createLoyaltyRequest = async (
  params: ICreateLoyaltyRequestParams,
  config: ApiRequestConfig,
): Promise<ICreateLoyaltyResponse> =>
  api.post<ICreateLoyaltyResponse>(
    'loyalty-registration-modal/create-loyalty',
    {
      keycardType: params.keycardType,
      marketingConsent: params.marketingConsent,
      regionId: params.regionId,
    },
    config,
  );
